import {
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import {styled} from "@mui/system";
import {
  Button,
  Field,
  FieldsContainer,
  Form,
  FormToolbar,
  PasswordField,
  Spacer,
  TextField,
} from "common";
//@ts-ignore
import {ReactComponent as ReactLogo} from "assets/logo.svg";
import useLoginFrom from "features/identity/useLoginFrom";
import I18n from "i18n-js";
import {Link} from "react-router-dom";
import PageTransition from "./PageTransition";

const Logo = styled(ReactLogo)`
    max-height: 70px;
    min-height: 70px;
`;

export default function LoginForm() {
  const theme = useTheme();
  const {
    item,
    errors,
    onChange,
    login,
    loading,
    emailFieldRef,
    passwordFieldRef,
    autofilled,
  } = useLoginFrom({});

  return (
    <PageTransition direction={-1}>
      <Box
        flex={1}
        flexDirection="column"
        display="flex"
        alignItems="center"
        //justifyContent="center"
        padding={4}
      >
        <Grid container justifyContent="center">
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Paper
              sx={{
                padding: 4,
                maxWidth: "sm",
                backgroundColor: theme =>
                  alpha(theme.palette.background.paper, 0.95),
              }}
              elevation={5}
            >
              <Stack spacing={2} sx={{alignItems: "center"}}>
                <Link
                  to="/"
                  style={{
                    color: theme.palette.mode === "dark" ? "white" : "#001e3c",
                  }}
                >
                  <Logo/>
                </Link>
                <Typography variant="h2">{I18n.t("App.title")}</Typography>
                <Typography variant="h5">{I18n.t("Login.title")}</Typography>
              </Stack>
              <Spacer h={4}/>
              <Form
                item={item}
                errors={errors}
                onChange={onChange}
                translationCategory="Login.attributes"
              >
                <FieldsContainer>
                  <Field xs={12}>
                    <TextField
                      id="email"
                      InputLabelProps={{shrink: autofilled}}
                      inputRef={emailFieldRef}
                      useDelayedKeystrokes={false}
                      onEnter={() => login()}
                    />
                  </Field>
                  <Field xs={12}>
                    <PasswordField
                      inputRef={passwordFieldRef}
                      InputLabelProps={{shrink: autofilled}}
                      id="password"
                      useDelayedKeystrokes={false}
                      onEnter={() => login()}
                    />
                  </Field>
                </FieldsContainer>
              </Form>
              <Spacer h={2}/>
              <FormToolbar variant="dense">
                <Spacer right/>
                <Button
                  variant="contained"
                  loading={loading}
                  fullWidth
                  onClick={() => login()}
                >
                  {I18n.t("Login.login")}
                </Button>
              </FormToolbar>
              <Link
                to="/password-recovery"
                style={{
                  color: theme.palette.mode === "dark" ? "white" : "#001e3c",
                }}
              >
                {I18n.t("Login.password-recovery")}
              </Link>
              <Spacer h={1}/>
              {I18n.t("Login.dontHaveAnAccount")} <Link
              to="/register"
              style={{
                color: theme.palette.mode === "dark" ? "white" : "#001e3c",
              }}
            >
              {I18n.t("Login.register")}
            </Link>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </PageTransition>
  );
}
